import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="karten-form"
export default class extends Controller {
	static targets = [
		"hiddenFieldErledigt",
		"hiddenFieldLabel",
		"hiddenFieldZustaendiger",
		"inputFieldFrist",
		"labelContainer",
		"erledigtContainer",
		"zustaendigerContainer",
	]

	connect() {}

	submitOnEnter(event) {
		if (event.key === "Enter" && !event.shiftKey) {
			event.preventDefault() // verhindert den Zeilenumbruch
			event.target.blur() // entfernt den Fokus vom aktuellen Element
			this.submit()
		}
	}

	updateErledigt() {
		// hidden_field updaten
		const value = this.hiddenFieldErledigtTarget.value
		this.hiddenFieldErledigtTarget.value = 1 - value
		// SVG updaten
		this.erledigtContainerTarget.innerHTML = this.getSvgErledigt(
			this.hiddenFieldErledigtTarget.value,
		)
		// Formular abschicken
		this.submit()
	}

	updateLabel({ currentTarget }) {
		// hidden_field updaten
		this.hiddenFieldLabelTarget.value = currentTarget.dataset.labelvalue
		// SVG-Farbe updaten
		const svgElement = this.labelContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add(
			this.getFarbeLabel(currentTarget.dataset.labelvalue),
		)
		// Label-Text updaten
		const textElement = this.labelContainerTarget.querySelector("div")
		textElement.innerHTML = currentTarget.querySelector("span").innerHTML
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-labelvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		currentTarget.classList.add("!border-gray-300")
		// Remove-Icon hinzufügen
		this.element
			.querySelector("#karten_label_remove_icon")
			.classList.remove("hidden")
		// Formular abschicken
		this.submit()
	}

	removeLabel() {
		// hidden_field updaten
		this.hiddenFieldLabelTarget.value = "ohne"
		// SVG-Farbe updaten
		const svgElement = this.labelContainerTarget.querySelector("svg")
		svgElement.classList.forEach((cls) => {
			if (cls.startsWith("fill-")) svgElement.classList.remove(cls)
		})
		svgElement.classList.add("fill-farbe-grau")
		// Label-Text updaten
		const textElement = this.labelContainerTarget.querySelector("div")
		textElement.innerHTML = "Label hinzufügen"
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-labelvalue]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		// Remove-Icon entfernen
		this.element
			.querySelector("#karten_label_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	updateZustaendiger({ currentTarget }) {
		// hidden_field updaten
		this.hiddenFieldZustaendigerTarget.value = currentTarget.dataset.userid
		// Name updaten
		const nameElement =
			this.zustaendigerContainerTarget.querySelector("div")
		nameElement.innerHTML = currentTarget.innerHTML
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-userid]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		currentTarget.classList.add("!border-gray-300")
		// Remove-Icon hinzufügen
		this.element
			.querySelector("#karten_zustaendiger_remove_icon")
			.classList.remove("hidden")
		// Formular abschicken
		this.submit()
	}

	removeZustaendiger() {
		// hidden_field updaten
		this.hiddenFieldZustaendigerTarget.value = ""
		// Name updaten
		const nameElement =
			this.zustaendigerContainerTarget.querySelector("div")
		nameElement.innerHTML = "Zuständigen hinzufügen"
		// Selectbox updaten
		const elements = this.element.querySelectorAll("[data-userid]")
		elements.forEach((element) => {
			element.classList.remove("!border-gray-300")
		})
		// Remove-Icon entfernen
		this.element
			.querySelector("#karten_zustaendiger_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	updateFrist() {
		this.formatiereFrist()

		// Remove-Icon hinzufuegen oder entfernen
		if (this.inputFieldFristTarget.value == "") {
			this.element
				.querySelector("#karten_frist_remove_icon")
				.classList.add("hidden")
		} else {
			this.element
				.querySelector("#karten_frist_remove_icon")
				.classList.remove("hidden")
		}
		// Formular abschicken
		this.submit()
	}

	updateFristOnEnter(event) {
		if (event.key === "Enter" && !event.shiftKey) {
			event.target.parentNode.parentNode.dispatchEvent(
				new Event("click", { bubbles: true }),
			) // Irgendwo hinklicken, damit Dropdown zu geht
			event.target.blur() // entfernt den Fokus vom aktuellen Element
			this.updateFrist()
		}
	}

	addFristPlaceholderInfo() {
		this.inputFieldFristTarget.placeholder = "TT.MM.JJJJ"
	}

	removeFristPlaceholderInfo() {
		setTimeout(() => {
			this.inputFieldFristTarget.placeholder = "Frist hinzufügen"
		}, 200)
	}

	removeFrist() {
		// input_field updaten
		this.inputFieldFristTarget.value = ""
		// placeholder updaten
		this.removeFristPlaceholderInfo
		// Remove-Icon entfernen
		this.element
			.querySelector("#karten_frist_remove_icon")
			.classList.add("hidden")
		// Formular abschicken
		this.submit()
	}

	submit() {
		this.element.requestSubmit()
	}

	// private
	getSvgErledigt(value) {
		const options = {
			0: '<svg class="size-10 fill-farbe-grau cursor-pointer" id="glyphicons-basic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path id="circle-empty" d="M16,5A11,11,0,1,0,27,16,11.01245,11.01245,0,0,0,16,5Zm0,19a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,16,24Z"/></svg>',
			1: '<svg class="size-10 fill-[#9FD356] cursor-pointer" id="glyphicons-basic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path id="circle-check" d="M16,4A12,12,0,1,0,28,16,12.01312,12.01312,0,0,0,16,4Zm6.5697,8.40088-7.29217,8.62744a1,1,0,0,1-1.50623.02429L9.88147,16.741a.5.5,0,0,1,.00616-.67652l1.137-1.21508a.5.5,0,0,1,.63354-.0802l2.611,1.66149,6.57276-5.69458a.5.5,0,0,1,.67114.01465l1.01856.96424A.5.5,0,0,1,22.5697,12.40088Z"/></svg>',
		}
		return options[value]
	}

	getFarbeLabel(farbe) {
		const farbeMap = {
			ohne: "fill-farbe-grau",
			blau: "fill-labelblau",
			gruen: "fill-labelgruen",
			lila: "fill-labellila",
			gelb: "fill-labelgelb",
			rot: "fill-labelrot",
		}
		return farbeMap[farbe]
	}

	formatiereFrist() {
		const date = moment(this.inputFieldFristTarget.value, "DDMMYYYY")

		if (date.isValid()) {
			this.inputFieldFristTarget.value = date.format("DD.MM.YYYY")
		} else {
			this.inputFieldFristTarget.value = ""
		}
	}
}
